import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { Page } from '../model/Page';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileResponseModel } from '../model/FileResponseModel';
import { AllotmentLetterListModel } from '../model/AllotmentLetterListModel';
import { LetterListModel } from '../model/LetterListModel';

@Injectable({
  providedIn: 'root'
})
export class LettersService {
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }

  initPage() {
    return this.httpClient.get<{lotteryList: {[key: number]: string}, status: string, errorMessage: string}>(ApiUrls.lettersListInitUrl);
  }

  fetchSchemeForLotteryEvent(lotteryEventId: number) {
    return this.httpClient.get<{schemeList: {[key: number]: string}, status: string, errorMessage: string}>(
      ApiUrls.lettersListFetchSchemeByLotteryUrl.replace('{lotteryEventId}', lotteryEventId.toString()));
  }

  fetchCategoryForScheme(schemeId: number) {
    return this.httpClient.get<{categoryList: {[key: number]: string}, status: string, errorMessage: string}>(
      ApiUrls.lettersListFetchCategoryBySchemeUrl.replace('{schemeId}', schemeId.toString()));
  }

  fetchApplicationListForLetterType(page: number,
    size: number, letterType: string, lotteryEventId: number, schemeId: number, categoryId: number, filterText: string, 
    applicationDrawStatus: string, unsignedAllotmentGenerationStatus: string, unsignedPossessionGenerationStatus: string,
    unsignedPOLGenerationStatus: string, pendingDocOrWarn: string) {
    return this.httpClient.post<{data: Page<LetterListModel>, status: string, errorMessage: string}>(
        ApiUrls.lettersListFetchPageByFilterUrl + `?page=${page}&size=${size}`, {
          letterType, lotteryEventId, schemeId, categoryId, filterText, applicationDrawStatus, 
          unsignedAllotmentGenerationStatus,unsignedPossessionGenerationStatus,unsignedPOLGenerationStatus,
          pendingDocOrWarn
        });
  }

  downloadAllLetter(letterType: string, lotteryEventId: number, schemeId: number, categoryId: number, filterText: string, applicationDrawStatus: string, 
    unsignedAllotmentGenerationStatus: string, unsignedPossessionGenerationStatus: string,
    unsignedPOLGenerationStatus: string, pendingDocOrWarn: string) {
    return this.httpClient.post<{base64File: string, fileName: string, status: string, errorMessage: string}>(
      ApiUrls.lettersListDownloadAllLetterUrl, {
        letterType, lotteryEventId, schemeId, categoryId, filterText, applicationDrawStatus, 
        unsignedAllotmentGenerationStatus, unsignedPossessionGenerationStatus, unsignedPOLGenerationStatus, 
        pendingDocOrWarn
      });
  }

  downloadLetter(letterType: string, applicationId: number, unsignedPossessionGenerationStatus: string, 
    unsignedAllotmentGenerationStatus: string, unsignedPOLGenerationStatus: string) {
    return this.httpClient.post<{base64File: string, fileName: string, status: string, errorMessage: string}>(
      ApiUrls.lettersListDownloadLetterUrl, {
        letterType, applicationId, unsignedPossessionGenerationStatus, 
        unsignedAllotmentGenerationStatus, unsignedPOLGenerationStatus
      });
  }

  fetchAllotmentLetterList(
    lotteryEventId: number,
    page: number,
    size: number,
    filterText: string,
    letterTypeFilter: string,
    schemeFilter:string,
  ) {
    let apiUrl = ApiUrls.allotmentLetterList.replace(`{lotteryEventId}`, lotteryEventId.toString()) +
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : '') +
      (letterTypeFilter ? `&letterTypeFilter=${letterTypeFilter}` : '') +
      (schemeFilter ? `&schemeFilter=${schemeFilter}` : '');
  
    // Corrected console.log statement
    console.log("letterTypeFilter: " + (letterTypeFilter ? `&letterTypeFilter=${letterTypeFilter}` : ""));
  
    return this.httpClient.get<Page<AllotmentLetterListModel>>(apiUrl);
  }
  getLotteryName() {
    return this.httpClient.get<AllotmentLetterListModel>(ApiUrls.lotteryNameList);
  }

  getSchemeName(lotteryEventId: number) {
    return this.httpClient.get<AllotmentLetterListModel>(ApiUrls.schemeCodeList.replace(`{lotteryEventId}`, lotteryEventId.toString()));
  }

  fetchSchemeList(page: number, size: number, filterText: any) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<AllotmentLetterListModel>>(
      ApiUrls.schemeList + reqParams
    );
  }
  
  fetchAllotmentLetterGenerationDetail(applicationNo: number) {
    return this.httpClient.get<AllotmentLetterListModel>(ApiUrls.allotmentLetterGenerationDetail.replace('{applicationNo}', applicationNo.toString()));
  }
  
  //generateAllotmentLetter
  generateAllotmentLetter(applicationNo: number){
    return this.httpClient.get<FileResponseModel>(ApiUrls.generateAllotmentLetter.replace('{applicationNo}', applicationNo.toString()));
  }

  //getAllotmentLetterFile
  getAllotmentLetterFile(applicationNo: number){
    return this.httpClient.get<FileResponseModel>(ApiUrls.getAllotmentLetter.replace('{applicationNo}', applicationNo.toString()));
  }

  generateUnsignedPOL(applicationId: number) {
    return this.httpClient.get<FileResponseModel>(
      ApiUrls.generateUnsignedPOL.replace('{applicationId}', applicationId.toString()));
  }

  generateUnsignedAllotmentLetter(applicationId: number) {
    return this.httpClient.get<FileResponseModel>(
      ApiUrls.generateUnsignedAllotmentLetter.replace('{applicationId}', applicationId.toString()));
  }

  viewDraftAllotmentLetter(applicationId: number) {
    return this.httpClient.get<FileResponseModel>(
      ApiUrls.viewDraftAllotmentLetter.replace('{applicationId}', applicationId.toString()));
  }

  publishDraftAllotmentLetter(applicationId: number) {
    return this.httpClient.get<{status: string, errorMessage: string}>(
      ApiUrls.publishDraftAllotmentLetter.replace('{applicationId}', applicationId.toString()));
  }

  generateUnsignedPossessionLetter(applicationId: number) {
    return this.httpClient.get<FileResponseModel>(
      ApiUrls.generateUnsignedPossessionLetter.replace('{applicationId}', applicationId.toString()));
  }

  sendPossessionLetterForEsign(applicationId: number) {
    return this.httpClient.get<{status: string, errorMessage: string}>(
      ApiUrls.sendPossessionLetterForEsign.replace('{applicationId}', applicationId.toString()));
  }

  checkEsignStatusForPossession(applicationId: number) {
    return this.httpClient.get<{status: string, errorMessage: string}>(
      ApiUrls.checkEsignStatusForPossession.replace('{applicationId}', applicationId.toString()));
  }

  signWithDSC(applicationId: number) {
    return this.httpClient.get<{redirectUrl: string, status: string, errorMessage: string}>(
      ApiUrls.signPossessionLetterWithDSCUrl.replace('{applicationId}', applicationId.toString()));
  }

  checkPossessionDSCSignStatus(applicationId: number) {
    return this.httpClient.get<{redirectUrl: string, status: string, errorMessage: string}>(
      ApiUrls.checkPossessionDSCSignStatusUrl.replace('{applicationId}', applicationId.toString()));
  }

  publishPossessionLetter(applicationId: number) {
    return this.httpClient.get<{redirectUrl: string, status: string, errorMessage: string}>(
      ApiUrls.publishPossessionLetterUrl.replace('{applicationId}', applicationId.toString()));
  }
  
  signWithDSCAllotment(applicationId: number) {
    return this.httpClient.get<{redirectUrl: string, status: string, errorMessage: string}>(
      ApiUrls.signAllotmentLetterWithDSCUrl.replace('{applicationId}', applicationId.toString()));
  }

  checkAllotmentDSCSignStatus(applicationId: number) {
    return this.httpClient.get<{redirectUrl: string, status: string, errorMessage: string}>(
      ApiUrls.checkAllotmentDSCSignStatusUrl.replace('{applicationId}', applicationId.toString()));
  }

  publishAllotmentLetter(applicationId: number) {
    return this.httpClient.get<{redirectUrl: string, status: string, errorMessage: string}>(
      ApiUrls.publishAllotmentLetterUrl.replace('{applicationId}', applicationId.toString()));
  }

  async successToast(msg) {
    await this._snackBar.open(
      msg,
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }

}
